import { render, staticRenderFns } from "./bindingBank.vue?vue&type=template&id=7116c856&scoped=true&"
import script from "./bindingBank.vue?vue&type=script&lang=js&"
export * from "./bindingBank.vue?vue&type=script&lang=js&"
import style0 from "./bindingBank.vue?vue&type=style&index=0&id=7116c856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7116c856",
  null
  
)

export default component.exports